import axios from "axios";
import {getJWT} from "./auth";

const client = axios.create();

/* generic fetching method */
export const fetchData = async (
    url,
    uid = window.localStorage.getItem("automl-uid"),
) => {
    try {
        const response = await client.get(url, {
            // authorization Header
            headers: {
                Authorization: `Bearer ${await getJWT()}`,
                "X-UID": uid,
                "Content-Type": "application/json",
            },
            withCredentials: true
        });
        if (response.status === 206) {
            // redirect to legacy info page
            window.location.href = "https://kilab-ee.zsw-bw.de/info/?page_id=668"
        }
        if (response.status === 208) {
            // redirect to wait for approval page
            window.location.href = "https://kilab-ee.zsw-bw.de/info/?page_id=673"
        }
        return response.data;
    } catch (error) {
        console.error(`An Error occured while fetching data from ${url}:`, error);
        return error;
    }
};

export const fetchDataBlob = async (
    url,
    uid = window.localStorage.getItem("automl-uid"),
) => {
    const response = await fetch(url, {
        // authorization Header
        headers: {
            Authorization: `Bearer ${await getJWT()}`,
            "X-UID": uid,
            "Content-Type": "application/json",
        },
        withCredentials: true
    });
    if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        return downloadUrl;
    }

    return response.blob();
};


/* generic post method */
export const postData = async (
    url,
    data,
    uid = window.localStorage.getItem("automl-uid"),
) => {
    const jsonData = JSON.stringify(data);
    console.log("jsonData", jsonData);
    try {
        const response = await axios.post(url, jsonData, {
            // authorization Header
            headers: {
                Authorization: `Bearer ${await getJWT()}`,
                "X-UID": uid,
                "Content-Type": "application/json",
            },
            timeout: 50000,
        });
        return response;
    } catch (error) {
        console.error(`An Error occurred while fetching data from ${url}:`, error);
        return {
            status: error.response.status,
            detail: error.response.data.detail,
            message: error.response.data.message,
        };
    }
};

/* generic delete method */
export const deleteData = async (
    url,
    uid = window.localStorage.getItem("automl-uid"),
) => {
    try {
        const response = await axios.delete(url, {
            // authorization Header
            headers: {
                Authorization: `Bearer ${await getJWT()}`,
                "X-UID": uid,
                "Content-Type": "application/json",
            },
        });
        return response;
    } catch (error) {
        console.error(`An Error occurred while deleting data from ${url}:`, error);
        if (error.response) {
            return {
                status: error.response.status,
                detail: error.response.data.detail,
                message: error.response.data.message,
            };
        }
        return {
            status: null,
            detail: "Network Error",
            message: error.message,
        };

    }
};
/* file upload */
export const uploadData = async (
    url,
    formData,
    uid = window.localStorage.getItem("automl-uid")
) => {
    try {
        // Append the new parameter to the formData
        const response = await axios.post(url, formData, {
            headers: {
                Authorization: `Bearer ${await getJWT()}`,
                "X-UID": uid,
                "Content-Type": "multipart/form-data",
            },
            timeout: 150000,
        });
        return response;
    } catch (error) {
        console.error(`An Error occured while fetching data from ${url}:`, error);
        // return { status: error.response.status, data: "Could not be uploaded" };

        return {
            status: error.response.status,
            detail: error.response.data.detail,
        };

    }
};
